import { render, staticRenderFns } from "./fl44-new-proposal-action-button.vue?vue&type=template&id=bc67bff8&"
import script from "./fl44-new-proposal-action-button.vue?vue&type=script&lang=js&"
export * from "./fl44-new-proposal-action-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc67bff8')) {
      api.createRecord('bc67bff8', component.options)
    } else {
      api.reload('bc67bff8', component.options)
    }
    module.hot.accept("./fl44-new-proposal-action-button.vue?vue&type=template&id=bc67bff8&", function () {
      api.rerender('bc67bff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl44-notices/partials/fl44-new-proposal-action-button.vue"
export default component.exports